import { Commitment, Invoice } from 'dashboard/models/invoice';
import {
  CurrentInvoiceActions,
  CurrentInvoiceActionType,
} from 'dashboard/redux/actions/current-invoice';

export interface CurrentInvoiceState {
  currentInvoice: Invoice;
  commitments: Commitment[];
}

const initialInvoiceState: CurrentInvoiceState = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  currentInvoice: undefined,
  commitments: [],
};

export default (
  state: CurrentInvoiceState = initialInvoiceState,
  action: CurrentInvoiceActions,
) => {
  switch (action.type) {
    case CurrentInvoiceActionType.SetCurrentInvoice: {
      return {
        ...state,
        currentInvoice: action.payload.currentInvoice,
        commitments: action.payload.commitments,
      };
    }

    default:
      return state;
  }
};
